
import { Button } from "@mui/material";
import * as React from "react";
import { PopupMessage } from "../../utils/message";

interface Props {
    error?: {
        error?: Error;
        stack?: {
            componentStack?: string;
        };
    };
}
export class FatalError extends React.Component<Props, {}> {
    constructor(props) {
        super(props);
    }

    getErrorText() {
        const { error } = this.props;
        const lines = [
            `path: ${window.location.href}`,
            `error: ${error?.error?.name || "UnknownError"}: ${error?.error?.message || ""}`,
            ``,
            `errorStack:`,
            error?.error?.stack || "",
            ``,
            `componentStack:`,
            error?.stack?.componentStack || "",
        ];
        return lines.join("\n");
    }

    copyError() {
        navigator.clipboard.writeText(this.getErrorText());
        PopupMessage.success("Copied.");
    }

    render() {
        const { error } = this.props;

        return <div id="internal-error">
            <div className="internal-error">
                <div className="internal-error-500">
                    <h1>500</h1>
                </div>

                <h2>Internal server error!</h2>

                <div className="error-stack" style={{ whiteSpace: "pre-wrap", textAlign: "left", fontSize: 12 }}>
                    <b>{error?.error?.name}: {error?.error?.message}</b>
                    {"\n\n"}
                    {error?.error?.stack}
                    {"\n\nComponent stack:"}
                    {error?.stack?.componentStack}
                </div>

                <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => this.copyError()}
                >
                    Copy to clipboard
                </Button>
            </div>
        </div>
    }
}
